module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "rows",
      "cols": "cols",
      "maxlength": "maxlength",
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.diff) + " caracter(es) restante(s).")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f601722","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input/DWTextarea.vue
// module id = 881
// module chunks = 1